import { render, staticRenderFns } from "./text-highlight-up.vue?vue&type=template&id=3e32916e&scoped=true&"
var script = {}
import style0 from "./text-highlight-up.vue?vue&type=style&index=0&id=3e32916e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e32916e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e32916e')) {
      api.createRecord('3e32916e', component.options)
    } else {
      api.reload('3e32916e', component.options)
    }
    module.hot.accept("./text-highlight-up.vue?vue&type=template&id=3e32916e&scoped=true&", function () {
      api.rerender('3e32916e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/text-highlight-up.vue"
export default component.exports